/**
 * Centralized Environment Configuration
 *
 * Single source of truth for all environment variables and derived configuration.
 * Import `env` from this module instead of accessing import.meta.env directly.
 */

/**
 * All environment variables used in the application.
 * Provides centralized access with type safety.
 */
export const env = {
  // Multi-tenancy
  tenantSlug: import.meta.env.VITE_TENANT_SLUG || "ad-audio",

  // Site Configuration
  siteUrl: import.meta.env.VITE_SITE_URL || "https://ad.audio",

  // CMS Configuration
  cmsApiUrl: import.meta.env.VITE_CMS_API_URL || "http://localhost:3000",

  // Cookie Consent
  usercentricsSettingsId: import.meta.env.VITE_USERCENTRICS_SETTINGS_ID as string | undefined,

  // Secrets (server-only at runtime, accessed via process.env)
  revalidateSecret: process.env.REVALIDATE_SECRET as string | undefined,

  // Feature flags
  debugEnabled: import.meta.env.VITE_DEBUG_ENABLED as string | undefined,

  // Environment flags
  isDev: import.meta.env.DEV as boolean,
  isProd: import.meta.env.PROD as boolean,
  mode: import.meta.env.MODE as string,
} as const;

// ─── Required Variable Validation ─────────────────────────────────────────────
// Warn at module load for required vars without defaults that are missing.

const requiredVars: Array<[keyof typeof env, string]> = [
  ["usercentricsSettingsId", "VITE_USERCENTRICS_SETTINGS_ID"],
];

for (const [key, envVar] of requiredVars) {
  if (!env[key]) {
    console.warn(`[env] Missing required variable ${envVar} — feature may not work`);
  }
}
